import React, { Component, Fragment } from 'react';
import { connect, Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.css';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { enUS, ptBR } from '@material-ui/core/locale';
import '../../scss/app.scss';
import PropTypes from 'prop-types';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import {environment} from '../../containers/environment';
import Loading from '../../shared/components/Loading';

i18n.init(i18nextConfig);

//const ThemeComponent = ({ children, themeName }) => {
const ThemeComponent = ({ children }) => {
  let lng = localStorage.getItem(environment.LANGUAGE);
  let option = ptBR;
  if(lng !== null && lng !== undefined){
    switch (lng) {
      case 'br':
        option =  ptBR;
        break;
      case 'en':
        option =  enUS;
        break;
      default:
        option =  ptBR;
        break;
    }
  }
  const theme = createMuiTheme({
    palette: {
      //type: themeName === 'theme-dark' ? 'dark' : 'light',
      type: 'light',
    },
  }, option);
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

// ThemeComponent.propTypes = {
//   children: PropTypes.arrayOf(PropTypes.element).isRequired,
//   themeName: PropTypes.string.isRequired,
// };

const ConnectedThemeComponent = connect(state => ({ themeName: state.theme.className }))(ThemeComponent);

class App extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
    };
  }

  componentDidMount() {
    window.addEventListener('load', () => {
      this.setState({ loading: false });
      setTimeout(() => this.setState({ loaded: true }), 500);
    });
  }

  render() {
    const { loaded, loading } = this.state;

    // MCCOSTA: BrowserRouter => ROTAS PARA CRUD  basename

    return (
      <Provider store={store}>
          <BrowserRouter basename="">
            <I18nextProvider i18n={i18n}>
              <ScrollToTop>
                <Fragment>
                  {!loaded
                      && (
                        <Loading loading={loading} />
                      )
                    }
                  <ConnectedThemeComponent>
                    <div>
                      <Router />
                    </div>
                  </ConnectedThemeComponent>
                </Fragment>
              </ScrollToTop>
            </I18nextProvider>
          </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
